@if (dataBanner()) {
  <div
    class="container-bg"
    [ngStyle]="{ 'background-image': backgroundImage }">
    <div class="container banner-info">
      <div
        class="info-container {{
          dataBanner()?.isMain ? 'primary' : 'secondary'
        }} row align-items-center align-content-between {{
          !dataBanner()?.isMain ? 'flex-row-reverse' : ''
        }}">
        <div
          class="info-container__info {{
            dataBanner()?.products?.length ? 'col-lg-3'
            : !dataBanner()?.isMain ? 'col-lg-4 min'
            : 'col-lg-5 min'
          }} col-md-12 col-sm-12 col-12 {{
            !dataBanner()?.isMain ? 'mt-xxl-0 mt-xxl-0 mt-lg-0 mt-md-5 mt-sm-3 mt-xs-5' : ''
          }}">
          <div
            class="banner-info__grid {{
              !dataBanner()?.isMain ? 'mt-xxl-0 mt-xxl-0 mt-lg-0 mt-md-5 mt-sm-0 mt-xs-5' : ''
            }}">
            <div class="banner-info__grid-top">
              @if (dataBanner()?.logoUrl) {
                <img
                  class="banner-info__logo"
                  [src]="dataBanner()?.logoUrl" />
              }
              @if (dataBanner()?.title) {
                <h2 class="banner-info__title txt_section-name">
                  {{ dataBanner()?.title }}
                </h2>
              }
              @if (dataBanner()?.description) {
                <p
                  class="banner-info__description txt_body {{
                    !dataBanner()?.isMain ?
                      'mb-xxl-5 mb-xxl-5 mb-lg-5 mb-md-0 mb-sm-0 mb-xs-0 '
                    : ''
                  }}">
                  {{ dataBanner()?.description }}
                </p>
              }
            </div>
            <div
              class="banner-info__grid-bottom d-xxl-flex d-xl-flex d-lg-flex flex-xxl-column flex-xl-column flex-lg-column d-md-none d-sm-none d-none">
              @if (dataBanner()?.buttonViewProductsDesc) {
                <cgw-action-button [data]="moreButton()"></cgw-action-button>
              }

              @if (dataBanner()?.linkConditionsDesc) {
                <a
                  class="banner-info__conditions txt_caption"
                  [href]="dataBanner()?.linkConditionsDesc"
                  target="_blank"
                  >Ver bases y condiciones</a
                >
              }
              @if (dataBanner()?.legalsDesc) {
                <span class="banner-info__legals txt_legals">{{ dataBanner()?.legalsDesc }}</span>
              }
            </div>
          </div>
        </div>

        @if (dataBanner()?.products?.length) {
          <div class="banner-products col-lg-9 col-md-12 col-sm-12 col-12">
            @for (product of dataBanner()?.products; track $index) {
              <cgw-product-card
                class="slide d-xxl-none d-xl-none d-lg-none d-md-none d-sm-block d-block"
                [product]="product">
              </cgw-product-card>
              <cgw-product-card
                class="slide d-xxl-block d-xl-block d-lg-block d-md-block d-sm-none d-none"
                [product]="product"
                [vertical]="true"
                [size]="'medium'">
              </cgw-product-card>
            }
          </div>
        }
        <div
          class="col-12 d-xxl-none d-xl-none d-lg-none d-md-grid d-sm-grid d-grid banner-info__grid-bottom">
          @if (dataBanner()?.buttonViewProductsDesc) {
            <cgw-action-button [data]="moreButton()"></cgw-action-button>
          }
          @if (dataBanner()?.linkConditionsDesc) {
            <a
              class="banner-info__conditions txt_caption"
              [href]="dataBanner()?.linkConditionsDesc"
              >Ver bases y condiciones</a
            >
          }
          @if (dataBanner()?.legalsDesc) {
            <span class="banner-info__legals txt_legals">{{ dataBanner()?.legalsDesc }}</span>
          }
        </div>
      </div>
    </div>
  </div>
}
